import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function CategoryEntries() {
  const movieCount = movies.filter((m) => m.type === "movie").length;
  const tvCount = movies.filter((m) => m.type === "tvseries").length;

  const entries = [
    {
      key: "movie",
      label: "国产电影",
      count: movieCount,
      desc: "剧情、动作、悬疑、科幻、历史等多题材国产影片",
      banner:
        "https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20with%20a%20glowing%20screen%20and%20rows%20of%20seats%2C%20editorial%20atmosphere%2C%20warm%20vermillion%20and%20charcoal%20tones%2C%20artistic%20style%2C%20no%20text&width=800&height=600&seq=entry-movie&orientation=landscape",
      icon: "ri-film-line",
    },
    {
      key: "tvseries",
      label: "国产电视剧",
      count: tvCount,
      desc: "家庭、都市、悬疑、古装、科幻等国产剧集",
      banner:
        "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20warm%20lamp%20light%20and%20a%20glowing%20television%2C%20editorial%20atmosphere%2C%20warm%20amber%20and%20muted%20earth%20tones%2C%20cinematic%20style%2C%20no%20text&width=800&height=600&seq=entry-tv&orientation=landscape",
      icon: "ri-tv-2-line",
    },
  ];

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.key}
            to={`/category/${entry.key}`}
            className="group relative flex flex-col justify-end h-64 md:h-72 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={entry.banner}
              alt={`${entry.label}分类入口`}
              title={`${entry.label} - 国产久久久`}
              className="absolute inset-0 w-full h-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-transparent"></div>
            <div className="relative z-10 p-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-3">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50">
                {entry.label}
              </h3>
              <p className="mt-1.5 text-sm text-background-200">{entry.desc}</p>
              <div className="mt-4 flex items-center gap-3">
                <span className="px-2.5 py-1 rounded-md bg-accent-500 text-foreground-950 text-xs font-medium">
                  共 {entry.count} 部
                </span>
                <span className="flex items-center gap-1 text-sm text-background-50 group-hover:gap-2 transition-all whitespace-nowrap">
                  进入分类
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}